import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-controls" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    appear: ""
  }, {
    default: _withCtx(() => [
      (_ctx.displayed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "modal-wrapper",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close($event)))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "header", {}, undefined, true),
                  _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
                  ]),
                  _createVNode(_component_font_awesome_icon, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                    class: "modal-default-button clickable",
                    icon: "fa-solid fa-times",
                    size: "lg",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "body", {}, () => [
                    _cache[2] || (_cache[2] = _createTextVNode("Loading...", -1 /* CACHED */))
                  ], true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }))
}